import { useMemo } from 'react';

const getApiAssetOrigin = () => {
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT || '';
  const fallbackOrigin = typeof window !== 'undefined' ? window.location.origin : '';

  try {
    return new URL(apiEndpoint || fallbackOrigin, fallbackOrigin).origin;
  } catch {
    return fallbackOrigin;
  }
};

const normalizeMediaUrl = (value = '') => {
  const mediaUrl = String(value || '').trim();
  if (!mediaUrl) return '';
  if (/^(data:|blob:)/i.test(mediaUrl)) return mediaUrl;

  const currentProtocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';

  if (mediaUrl.startsWith('//')) {
    return `${currentProtocol}${mediaUrl}`;
  }

  if (/^http:\/\//i.test(mediaUrl) && currentProtocol === 'https:') {
    return mediaUrl.replace(/^http:\/\//i, 'https://');
  }

  if (/^https?:\/\//i.test(mediaUrl)) {
    return mediaUrl;
  }

  const cleanPath = mediaUrl.replace(/^\/+/, '');
  return `${getApiAssetOrigin()}/${cleanPath}`;
};

export const getSlideMediaUrl = (slide = {}) => {
  const item = slide || {};

  const mediaUrl = [
    item.image,
    item.imageUrl,
    item.image_url,
    item.url,
    item.src,
    item.file,
  ].find((value) => typeof value === 'string' && value.trim().length > 0) || '';

  return normalizeMediaUrl(mediaUrl);
};

export const normalizeSlider = (slide) => ({
  ...(slide || {}),
  image: getSlideMediaUrl(slide),
});

export const getRenderableSliders = (sliders = []) => (
  (Array.isArray(sliders) ? sliders : [])
    .map(normalizeSlider)
    .filter((slide) => slide.image.trim().length > 0)
);

export const isSlideImage = (slide) => {
  const mediaUrl = getSlideMediaUrl(slide);
  if (/\.(mp4|webm|ogg|mov)(?:$|[?#])/i.test(mediaUrl)) return false;
  if ([false, 0, '0', 'false'].includes(slide?.isImage)) return false;
  if ([true, 1, '1', 'true'].includes(slide?.isImage)) return true;

  return true;
};

const noop = () => {};

export const useRenderableHeroSliders = (sliders = []) => {
  const heroSliders = useMemo(() => getRenderableSliders(sliders), [sliders]);

  return {
    heroSliders,
    markHeroSlideReady: noop,
    markHeroSlideFailed: noop,
  };
};
